export default "__VITE_PUBLIC_ASSET__810c24c2__"